<template>
    <img :src="imageUrl" class="avatar" alt="Avatar" />
</template>

<script>
export default {
    name: 'Avatar',
    props: {
        imageUrl: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.avatar {
    $avatar-size: 32px;

    width: $avatar-size;
    height: $avatar-size;
    border-radius: $avatar-size;
    border: 1px solid $inconvo-messenger-avatar-border-color;
    object-fit: cover;
}
</style>
